import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * panel-redesign-v3 T5 (REDISENO-PANEL.md §1 item 3): the former
 * Resumen/Monitoreo/Telemetría tabs are gone — `CampaignDetailScreen` is now
 * ONE page at `/campanas/:campaignId`. The two old tab sub-routes stay
 * reachable (an existing bookmark/link never 404s) but redirect (`replace`,
 * so Back doesn't bounce through the old sub-route) to that single page,
 * preserving any query string the caller carried (e.g. the list's own
 * `?estado=`/`page=`/`size=` context).
 *
 * Kept in its own file (not inline in `routes.tsx`) so that file keeps
 * exporting only non-component helpers/data alongside the one true
 * `AppShell`-adjacent route tree — `react-refresh/only-export-components`
 * otherwise flags a component defined among `routes.tsx`'s own
 * `migratedPage`/`extractRegisteredPaths`/`RegisteredRoute` exports.
 */
export function CampaignDetailSubrouteRedirect() {
  const { campaignId } = useParams<{ campaignId: string }>();
  const location = useLocation();
  return <Navigate to={`/campanas/${campaignId}${location.search}`} replace />;
}
